import { gql } from '@apollo/client';
import { COOKIE_KEY } from '@shared/constants';
import apolloClient from '.';
import { cookieOptions } from '@shared/utils';
import Cookies from 'js-cookie';
import { postLogoutAction } from '@shared/utils';

const REFRESH_TOKEN = gql`
  mutation RefreshToken($input: InputRefreshToken) {
    refreshToken(input: $input) {
      data {
        sessionId
        access
        accessTokenIssuedAt
        accessTokenExpiresAt
        refresh
        refreshTokenIssuedAt
        refreshTokenExpiresAt
      }
      message
    }
  }
`;

async function refreshToken() {
  const refreshToken = Cookies.get(COOKIE_KEY.refreshToken) ?? '';
  const sessionId = Cookies.get(COOKIE_KEY.sessionId) ?? '';
  if (!sessionId) {
    return postLogoutAction();
  }
  return apolloClient()
    .mutate({
      mutation: REFRESH_TOKEN,
      variables: {
        input: {
          sessionId,
          refreshToken,
        },
      },
    })
    .then((response) => {
      const { access, sessionId } = response.data.refreshToken.data;
      Cookies.set(COOKIE_KEY.accessToken, access ? 'Bearer ' + access : '', cookieOptions);
      Cookies.set(COOKIE_KEY.sessionId, sessionId ?? '', cookieOptions);
      return access;
    })
    .catch((err) => {
      console.info('[Refresh Token]', err);
      postLogoutAction();
    });
}

export default refreshToken;
